import DateTimeOperations from '@modules/husleie-framework/src/static-classes/DateTimeOperations.class';
import PhoneOperations from '@modules/husleie-framework/src/static-classes/PhoneOperations.class';
import UserStringOperations from '@modules/husleie-framework/src/static-classes/UserStringOperations.class';
import { User } from '@modules/husleie-framework/src/types/User.entity';
import { UserTranslationOptions } from '@modules/store/user/types/UserTranslationOptions.entity';

export default class UserConversionOperations {
  static apiToInternal(apiUser: any, options: UserTranslationOptions): undefined | User {
    let fullName: string;

    if (apiUser.fullName) {
      fullName = apiUser.fullName;
    } else {
      fullName = UserStringOperations.getFullName(
        UserStringOperations.getAppellationTranslation(options, apiUser.title?.common),
        UserStringOperations.getTitleTranslation(options, apiUser.title?.professional),
        apiUser.givenName,
        apiUser.familyName,
        options.indirect
      );
    }
    const phone = PhoneOperations.splitPhone(apiUser.cellPhone);

    return {
      email: apiUser.email,
      fullName,
      firstName: apiUser.givenName,
      lastName: apiUser.familyName,
      mobilePhone: phone ? { phonePrefix: phone.phonePrefix, phoneNumber: phone.phoneNumber } : undefined,
      title: apiUser.title?.professional,
      appellation: apiUser.title?.common,
      dateOfBirth: DateTimeOperations.apiDateToInternalDate(apiUser.dateOfBirth),
      placeOfBirth: apiUser.placeOfBirth,
      role: undefined,
    };
  }

  static internalToApi(user: undefined | User): any {
    if (user) {
      return {
        name: `${user.firstName} ${user.lastName}`,
        givenName: user.firstName,
        familyName: user.lastName,
        cellPhone: PhoneOperations.combinePhone(user?.mobilePhone?.phonePrefix, user?.mobilePhone?.phoneNumber),
        email: user.email,
        title: {
          common: user.appellation,
          professional: user.title && user.title !== 'NA' ? user.title : undefined,
        },
        dateOfBirth: DateTimeOperations.internalToApiDate(user.dateOfBirth),
        placeOfBirth: user.placeOfBirth,
      };
    }
    return {};
  }
}
